
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class RateFixingItemsGrid extends Serenity.EntityGrid<RateFixingItemsRow, any> {
        protected getColumnsKey() { return 'Sales.RateFixingItems'; }
        protected getDialogType() { return RateFixingItemsDialog; }
        protected getIdProperty() { return RateFixingItemsRow.idProperty; }
        protected getInsertPermission() { return RateFixingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return RateFixingItemsRow.localTextPrefix; }
        protected getService() { return RateFixingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}